import axiosInstance, { getRefreshToken } from "./axiosInstance";

export const envService = {
  getAllEnvs: async (
    id: string,
    clusterId: string,
    token: string
  ): Promise<any> => {
    try {
      if (id && clusterId) {
        axiosInstance.setAuthToken(token);
        const response = await axiosInstance.get(
          `/api/v1/organizations/${id}/clusters/${clusterId}/environments`
        );
        return response;
      }
      return;
    } catch (error: any) {
      if (error?.response?.status === 401) {
        const newToken = await getRefreshToken();
        if (newToken) {
          axiosInstance.setAuthToken(`Bearer ${newToken?.data?.access_token}`);
          return await axiosInstance
            .get(
              `/api/v1/organizations/${id}/clusters/${clusterId}/environments`
            )
            .then((response) => response.data);
        }
      }
      throw error;
    }
  },

  getEnvironmentByIdProject: async (
    organizationId: string,
    projectId: string
  ) => {
    const response = await axiosInstance.get(
      `/api/v1/organizations/${organizationId}/projects/${projectId}/environments`
    );
    return response.data;
  },
  getEnvironmentByOrganization: async (organizationId: string) => {
    const response = await axiosInstance.get(
      `/api/v1/organizations/${organizationId}/environments`
    );
    return response.data;
  }
};
